import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import {
  FormManuallyAddAccount,
  FormManuallyAddAccountProps
} from "../FormManuallyAddAccount";

type Props = {
  onClose: (externalBankAccount: ExternalBankAccount) => void;
} & FormManuallyAddAccountProps;

export const ModalFormManuallyAddAccount: React.FC<Props> = ({
  onClose,
  ...props
}) => {
  return (
    <FormManuallyAddAccount
      {...props}
      onSuccess={(...args) => {
        onClose(...args);
        props.onSuccess?.(...args);
      }}
    />
  );
};
